import {first} from 'rxjs/operators';
import {MatDialogRef} from '@angular/material/dialog';
import {Component} from '@angular/core';
import {CacheService} from '../../cache/cache.service';
import {LanguageService} from '../../language/language.service';

@Component({
  selector: 'message-dialog',
  template: `
    <app-dialog>
      <app-dialog-title>{{ title }}</app-dialog-title>
      <p mat-dialog-content [innerHtml]="message"></p>
      <app-dialog-action-button [primary]="true" (click)="dialogRef.close(true)">
        {{ labelDisplay }}
      </app-dialog-action-button>
    </app-dialog>
  `,
  standalone: false,
})
export class MessageDialog {
  public title: string;
  public message: string;
  public label: string = null;

  get labelDisplay(): string {
    return this.label ? this.label : 'OK';
  }

  constructor(
    public dialogRef: MatDialogRef<MessageDialog>,
    cacheService: CacheService,
  ) {
    if (this.label == null) {
      cacheService
        .getLanguageResource()
        .pipe(first())
        .subscribe(lr => {
          if (this.label == null) {
            this.label = LanguageService.translate('OK', 'OK', lr);
          }
        });
    }
  }
}
